import { useEffect, useState } from "react";
import { getGameId, getMyGameSettings } from "../../services/GameService";
import {
  DEFAULT_TIME_PROGRESSION,
  progressionFromSettings,
} from "./timeProgression";

// Loads the signed-in patient's configured target-time progression for a clock
// game (looked up by route path), falling back to the default on any failure.
export const useClockProgression = (routePath) => {
  const [progression, setProgression] = useState(DEFAULT_TIME_PROGRESSION);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const gameId = await getGameId(routePath);
        if (!gameId) return;
        const data = await getMyGameSettings(gameId);
        if (active) setProgression(progressionFromSettings(data.settings));
      } catch (e) {
        // Keep the default progression on any error.
      }
    })();
    return () => {
      active = false;
    };
  }, [routePath]);

  return progression;
};
